import React from 'react';
import Lottie from 'lottie-react';
import animationData from '../../assets/data/led.json';

const LedAnima = ({ className = '' }) => {
  return (
    <div className={`led-anima ${className}`}>
      <Lottie animationData={animationData} loop={true} autoplay={true} />
    </div>
  );
};

export default LedAnima;
